import { GridColumnMenuCheckboxFilter, GridColumnMenuProps } from '@progress/kendo-react-grid';
import React from 'react';

interface CheckboxColumnMenuProps extends GridColumnMenuProps {
    data: Array<string | object>;
    asiteLogs?: boolean;
}

const CheckboxColumnMenu: React.FC<CheckboxColumnMenuProps> = (props) => {
    let defaultFilter = [
        {
            status: 'Failure',
            emailSend: 'Yes',
        },
        {
            status: 'Running',
            emailSend: 'Yes',
        },
        {
            status: 'Success',
            emailSend: 'Yes',
        },
        {
            status: 'Waiting',
            emailSend: 'Yes',
        },
        {
            status: 'Warning',
            emailSend: 'No',
        },
        {
            status: 'Error',
            emailSend: 'No',
        },
    ];
    if (props?.asiteLogs) {
        defaultFilter = defaultFilter.filter((f) => f.status != 'Warning');
    }
    return (
        <div>
            {
                <GridColumnMenuCheckboxFilter
                    searchBox={() => null}
                    {...props}
                    expanded={true}
                    data={[...defaultFilter]}
                />
            }
        </div>
    );
};

export default CheckboxColumnMenu;
